import { render, staticRenderFns } from "./StackedAreaChart.vue?vue&type=template&id=3e252ba5&scoped=true"
import script from "./StackedAreaChart.vue?vue&type=script&lang=js"
export * from "./StackedAreaChart.vue?vue&type=script&lang=js"
import style0 from "./StackedAreaChart.vue?vue&type=style&index=0&id=3e252ba5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e252ba5",
  null
  
)

export default component.exports